export default "__VITE_ASSET__DFC2ule4__"